import React from "react";
import { Link } from "react-router-dom";

export function Overline({ children, className = "" }) {
  return <p className={`overline-label text-xs text-gold ${className}`}>{children}</p>;
}

export function SectionTitle({ children, className = "" }) {
  return (
    <h2 className={`font-heading font-700 uppercase tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05] ${className}`}>
      {children}
    </h2>
  );
}

function base(size) {
  const sizes = {
    md: "px-6 py-3 text-sm",
    lg: "px-7 py-4 text-base",
  };
  return `inline-flex items-center justify-center gap-2 font-heading font-600 tracking-wide rounded-sm transition-colors ${sizes[size] || sizes.md}`;
}

export function GoldButton({ children, to, href, onClick, size = "md", className = "", ...rest }) {
  const cls = `${base(size)} bg-gold hover:bg-gold-hover text-black ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} target="_blank" rel="noreferrer" className={cls} {...rest}>{children}</a>;
  return <button onClick={onClick} className={cls} {...rest}>{children}</button>;
}

export function OutlineButton({ children, to, href, onClick, size = "md", className = "", ...rest }) {
  const cls = `${base(size)} border border-white/25 text-white hover:border-gold hover:text-gold bg-white/0 hover:bg-white/5 ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} target="_blank" rel="noreferrer" className={cls} {...rest}>{children}</a>;
  return <button onClick={onClick} className={cls} {...rest}>{children}</button>;
}

export function PageHero({ overline, title, subtitle, image, children, logo }) {
  return (
    <section className="relative min-h-[52vh] lg:min-h-[62vh] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/75 to-black/40" />
      </div>
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pb-14 lg:pb-20 w-full">
        {logo && <img src={logo} alt="" className="w-16 h-16 lg:w-20 lg:h-20 rounded-full mb-5 border border-white/25 shadow-xl object-cover" />}
        {overline && <Overline className="mb-4">{overline}</Overline>}
        <h1 className="font-heading font-700 uppercase tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-zinc-300 text-base lg:text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
        {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
      </div>
    </section>
  );
}
